import React from "react";
import { cn } from "@/lib/utils";

type Tone = "neutral" | "pass" | "warn" | "fail" | "brand";

const FILL: Record<Tone, string> = {
  neutral: "", // base .vb-meter__fill is ink-3 (neutral), per the cheatsheet
  pass: "vb-meter__fill--pass",
  warn: "vb-meter__fill--warn",
  fail: "vb-meter__fill--fail",
  brand: "vb-meter__fill--brand",
};

type Props = {
  /** Current value. */
  value: number;
  /** Maximum value (defaults to 1, i.e. value is a 0–1 fraction). */
  max?: number;
  tone?: Tone;
  className?: string;
};

/** Horizontal meter, ported from the prototype's `.b-sov .bar` (canvas-soft
 *  track with a hairline border; neutral fill is the muted ink, not brand). */
export function MetricBar({ value, max = 1, tone = "neutral", className }: Props) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div
      className={cn("vb-meter", className)}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <span className={cn("vb-meter__fill", FILL[tone])} style={{ width: `${pct}%` }} />
    </div>
  );
}

export default MetricBar;
